import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = async (category, subcategory) => {
  const params = {};
  if (category && category !== "all") params.category = category;
  if (subcategory) params.subcategory = subcategory;
  const { data } = await api.get("/products", { params });
  return data;
};

export const fetchProduct = async (slug) => {
  const { data } = await api.get(`/products/${slug}`);
  return data;
};

export const subscribeNewsletter = async (email) => {
  const { data } = await api.post("/newsletter", { email });
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};
